import React from 'react'
import ChatbotHeroSection from './ChatbotHeroSection'
import WhyToxboxAIChatbot from './WhyToxboxAIChatbot'
import WhatToxboxBestChatbot from './WhatToxboxBestChatbot'
import ChatbotUseCases from './ChatbotUseCases'
import FixesChatbot from './FixesChatbot'

function Chatbot() {
    return (
        <div>
            <ChatbotHeroSection />
            <WhyToxboxAIChatbot />
            <WhatToxboxBestChatbot />
            <ChatbotUseCases />
            <FixesChatbot />
        </div>
    )
}

export default Chatbot
